/**
 * critique-types.ts — the typed `CritiqueRecord` schema for the JudgeCritiqueStore
 * (Epic gridline-marry-refinement Phase J5a).
 *
 * Schema SSOT (plain editor JSON asset, not a C# wire-contract): web/static/editor/judge-critique.schema.json.
 * Design: docs/epics/active/gridline-marry-refinement/phase-J5-design-260817.md
 * §3.1 (schema) + §T (types).
 *
 * WHY this module. A critique IS an editor correction (design §2): opening a
 * remediated PDF renders its `recovered` structure; the reviewer corrects it into
 * the `corrected` structure; the typed `delta` between them is the critique. Both
 * `recovered` and `corrected` are `GroundTruthDoc`-shaped — the "student answer" and
 * the "answer key" share one type (A.19 uniformity), so the same serializer + IoU
 * matcher serve both (INV-CRIT-CORRECTED-IS-GT).
 *
 * THE ORACLE (INV-CRIT-ORACLE). The durable critique oracle is the human correction
 * (`corrected` + the derived `derivedVerdict`), NEVER a stored judge verdict: the
 * frozen-regression guard re-checks FUTURE judge versions, so baking one version's
 * verdict in as truth would break the moment a new version is scored. `judgeProvenance`
 * is capture-time PROVENANCE ONLY — refinement/regression code reads `derivedVerdict`
 * and `corrected`, never `judgeProvenance`.
 *
 * Pure + Node-importable: type-only import of `GroundTruthDoc` and the 7-axis
 * `StructuralAxis`; no DOM globals at module scope.
 *
 * @module editor/critique-types
 */
/** Current CritiqueRecord schema version (semver). Mirrors GroundTruthDoc's. */
export const CRITIQUE_SCHEMA_VERSION = "1.0.0";
/** Iteration order for the categories (stable). */
export const CRITIQUE_CATEGORIES = [
    "Heading",
    "List",
    "Math",
    "Table",
    "ReadingOrder",
    "FigureAlt",
    "NoLeak",
    "StructuralMisroute",
    "Completeness",
];
